module.exports = __webpack_public_path__ + "2a8d332195feed67e327f1bc04b5bbd8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/earbuds-pink.png
// module id = 2314
// module chunks = 0